import { render } from "./configProcessTraining.vue?vue&type=template&id=13680020&scoped=true"
import script from "./configProcessTraining.js?vue&type=script&lang=js"
export * from "./configProcessTraining.js?vue&type=script&lang=js"

import "./configProcessTraining.vue?vue&type=style&index=0&id=13680020&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13680020"]])

export default __exports__